/* KAMUI 2026 wish list. No app, no login: the list is kept in this browser
   (localStorage) and shared as a link that carries the products and options. */
(function () {
  if (window.KamuiWishlist) return;
  var KEY = 'kamui-wishlist-v1';
  var NAME_KEY = 'kamui-wishlist-name';
  var MAX = 40;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() {
    try { var l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function write(l) {
    try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); } catch (e) {}
    document.dispatchEvent(new CustomEvent('kamui:wishlist', { detail: l }));
  }
  function same(a, h, v) { return a.h === h && String(a.v || '') === String(v || ''); }
  function has(h, v) { return read().some(function (a) { return same(a, h, v); }); }
  function add(h, v) { var l = read().filter(function (a) { return !same(a, h, v); }); l.unshift({ h: h, v: v ? String(v) : '' }); write(l); }
  function remove(h, v) { write(read().filter(function (a) { return !same(a, h, v); })); }
  function encode(l) { return l.map(function (a) { return a.h + (a.v ? '.' + a.v : ''); }).join(','); }
  function decode(s) {
    return (s || '').split(',').map(function (p) {
      var m = /^([a-z0-9][a-z0-9-]*)(?:\.(\d+))?$/.exec(p.trim());
      return m ? { h: m[1], v: m[2] || '' } : null;
    }).filter(Boolean).slice(0, MAX);
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  /* Product page button */
  function currentVariant(btn) {
    var scope = btn.closest('product-form-component, .product-information, .product-details, main') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (input && input.value) || btn.getAttribute('data-variant') || '';
  }
  function paint(btn) {
    var on = has(btn.getAttribute('data-handle'), currentVariant(btn));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-k-wish-label]');
    if (label) label.textContent = on ? btn.getAttribute('data-on') : btn.getAttribute('data-off');
  }
  function paintAll() { document.querySelectorAll('[data-k-wish]').forEach(paint); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-k-wish]');
    if (!btn) return;
    e.preventDefault();
    var h = btn.getAttribute('data-handle'), v = currentVariant(btn);
    if (has(h, v)) remove(h, v); else add(h, v);
    paint(btn);
  });
  document.addEventListener('change', function () { setTimeout(paintAll, 60); });
  document.addEventListener('variant:update', function () { setTimeout(paintAll, 60); });
  document.addEventListener('kamui:wishlist', paintAll);

  /* Wish list page */
  function fetchProduct(h) {
    return fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function img(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function renderPage(box) {
    var params = new URLSearchParams(location.search);
    var shared = params.has('items');
    var items = shared ? decode(params.get('items')) : read();
    var from = (params.get('from') || '').slice(0, 40);
    var grid = box.querySelector('[data-k-wl-grid]');
    var empty = box.querySelector('[data-k-wl-empty]');
    var share = box.querySelector('[data-k-wl-share]');
    var title = box.querySelector('[data-k-wl-title]');
    var sharedNote = box.querySelector('[data-k-wl-shared]');
    if (shared) {
      if (title) title.textContent = from ? from + '\u2019s wish list' : box.getAttribute('data-shared-title');
      if (sharedNote) sharedNote.hidden = false;
      var own = box.querySelector('[data-k-wl-own]'); if (own) own.hidden = true;
      if (share) share.hidden = true;
    }
    grid.innerHTML = '';
    if (!items.length) { empty.hidden = false; if (share) share.hidden = true; return; }
    empty.hidden = true;
    if (share && !shared) share.hidden = false;
    Promise.all(items.map(function (a) { return fetchProduct(a.h).then(function (p) { return { a: a, p: p }; }); }))
      .then(function (rows) {
        rows.forEach(function (row) {
          var p = row.p, a = row.a;
          if (!p) return;
          var variant = null;
          if (a.v) variant = p.variants.filter(function (x) { return String(x.id) === a.v; })[0] || null;
          if (!variant && p.variants.length === 1) variant = p.variants[0];
          var card = el('li', 'k-wl__item');
          var url = p.url + (variant ? '?variant=' + variant.id : '');
          var media = el('a', 'k-wl__media'); media.href = url;
          var src = (variant && variant.featured_image && variant.featured_image.src) || p.featured_image;
          if (src) { var im = el('img'); im.src = img(src, 600); im.alt = p.title; im.loading = 'lazy'; im.width = 600; im.height = 600; media.appendChild(im); }
          card.appendChild(media);
          var body = el('div', 'k-wl__body');
          var t = el('a', 'k-wl__title k-h3', p.title); t.href = url; body.appendChild(t);
          if (variant && variant.title && variant.title !== 'Default Title') body.appendChild(el('p', 'k-label k-muted', variant.title));
          body.appendChild(el('p', 'k-wl__price', money(variant ? variant.price : p.price)));
          var avail = variant ? variant.available : p.available;
          var actions = el('div', 'k-wl__actions');
          if (variant && avail) {
            var buy = el('button', 'k-btn k-btn--solid', box.getAttribute('data-add-label'));
            buy.type = 'button';
            buy.addEventListener('click', function () {
              buy.disabled = true;
              fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) })
                .then(function (r) { if (r.ok) location.href = root + 'cart'; else { buy.disabled = false; location.href = url; } })
                .catch(function () { location.href = url; });
            });
            actions.appendChild(buy);
          } else {
            var view = el('a', 'k-btn', avail === false ? box.getAttribute('data-soldout-label') : box.getAttribute('data-view-label')); view.href = url; actions.appendChild(view);
          }
          if (!shared) {
            var rm = el('button', 'k-link k-wl__remove', box.getAttribute('data-remove-label'));
            rm.type = 'button';
            rm.addEventListener('click', function () { remove(a.h, a.v); renderPage(box); });
            actions.appendChild(rm);
          }
          body.appendChild(actions);
          card.appendChild(body);
          grid.appendChild(card);
        });
        if (!grid.children.length) { empty.hidden = false; if (share) share.hidden = true; }
      });
  }

  function shareLink(box) {
    var nameInput = box.querySelector('[data-k-wl-name]');
    var name = nameInput ? nameInput.value.trim().slice(0, 40) : '';
    try { localStorage.setItem(NAME_KEY, name); } catch (e) {}
    var u = new URL(location.origin + location.pathname);
    u.searchParams.set('items', encode(read()));
    if (name) u.searchParams.set('from', name);
    return u.toString();
  }

  function wireShare(box) {
    var share = box.querySelector('[data-k-wl-share]');
    if (!share) return;
    var nameInput = box.querySelector('[data-k-wl-name]');
    try { if (nameInput) nameInput.value = localStorage.getItem(NAME_KEY) || ''; } catch (e) {}
    var status = box.querySelector('[data-k-wl-status]');
    var msg = box.getAttribute('data-share-message') || 'Here is my KAMUI wish list:';
    function say(t) { if (status) status.textContent = t; }
    share.addEventListener('click', function (e) {
      var b = e.target.closest('[data-k-wl-act]');
      if (!b) return;
      var link = shareLink(box);
      var act = b.getAttribute('data-k-wl-act');
      if (act === 'copy') {
        (navigator.clipboard ? navigator.clipboard.writeText(link) : Promise.reject())
          .then(function () { say(box.getAttribute('data-copied-label')); })
          .catch(function () { window.prompt('Copy this link', link); });
      } else if (act === 'email') {
        location.href = 'mailto:?subject=' + encodeURIComponent(box.getAttribute('data-email-subject') || 'My KAMUI wish list') + '&body=' + encodeURIComponent(msg + '\n\n' + link);
      } else if (act === 'sms') {
        location.href = 'sms:?&body=' + encodeURIComponent(msg + ' ' + link);
      } else if (act === 'native' && navigator.share) {
        navigator.share({ title: document.title, text: msg, url: link }).catch(function () {});
      }
    });
    var nb = share.querySelector('[data-k-wl-act="native"]');
    if (nb && !navigator.share) nb.hidden = true;
  }

  function init() {
    paintAll();
    document.querySelectorAll('[data-k-wishlist]').forEach(function (box) { wireShare(box); renderPage(box); });
  }
  window.KamuiWishlist = { read: read, add: add, remove: remove, has: has };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
